import { PropsWithChildren, useCallback, useState } from 'react';

import { Above, Below, Box, CollapseIcon, ExpandIcon, IconButton, Inline, u } from '@ui';

import { PlaybackPlayControls } from './Scrubber/PlaybackPlayControls';
import { PlaybackPositionControls } from './Scrubber/PlaybackPositionControls';
import * as css from './Scrubber/ThinPlaybackControls.css';

type ThinPlaybackControlsProps = PropsWithChildren<{ syncOnly?: boolean }>;

type ThinPlaybackControlRowProps = ThinPlaybackControlsProps & { showControls: boolean };

const ThinPlaybackControlRow = ({ children, syncOnly, showControls }: ThinPlaybackControlRowProps) => (
    <Inline flexWrap="wrap-reverse" alignItems="center" justifyContent="space-between" gap={u(1)}>
        {showControls && <PlaybackPlayControls />}
        {children}
        {showControls && <PlaybackPositionControls syncOnly={syncOnly} />}
    </Inline>
);

export const ThinPlaybackControls = ({ children, syncOnly }: ThinPlaybackControlsProps) => {
    const [controlsVisible, setControlsVisible] = useState(false);
    const handleControlsVisibilityChange = useCallback(() => {
        setControlsVisible((visible) => !visible);
    }, []);

    return (
        <Box position="relative">
            <Above bp="md">
                <ThinPlaybackControlRow syncOnly={syncOnly} showControls>
                    {children}
                </ThinPlaybackControlRow>
            </Above>
            <Below bp="md">
                <Box paddingBlockStart={u(5)} paddingBlockEnd={u(1)}>
                    <ThinPlaybackControlRow syncOnly={syncOnly} showControls={controlsVisible}>
                        {children}
                    </ThinPlaybackControlRow>
                    <IconButton
                        className={css.collapseButton}
                        onClick={handleControlsVisibilityChange}
                        size="small"
                        type="button"
                        variant="white"
                    >
                        {controlsVisible ? <CollapseIcon size={18} /> : <ExpandIcon size={18} />}
                    </IconButton>
                </Box>
            </Below>
        </Box>
    );
};
